import React, { useEffect, useRef } from 'react'
import './style.scss'
import '../../assets/style/main.css'
import { useState } from 'react'
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption'
import $ from 'jquery'
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import SignIn_Navbar from '../../components/SignIn_Navbar'
import { getAllConsent, getContact, setConsent, setContact } from '../../_actions/econsent.connection'
import { getJWTbyPatientID } from '../../_actions/sso.authen'
import { NhealthAction } from '../../_actions/action.api'
import { ALERT } from '../../components/CustomAlert'
import { useParams } from 'react-router-dom'
import { getJWT, isMembership, isMembershipNonLab } from '../../_actions/lineoa.authen'
import moment from 'moment'

function SignIn_PrivacyPolicy() {
    let onceMounth = useRef(true);
    let { type } = useParams(); //? signin, signup
    type = String(type).toLowerCase()

    const [canPass, setCanPass] = useState(false);
    const [choice_1, setChoice_1] = useState(false);
    const [choice_2, setChoice_2] = useState(false);
    const [choice_3, setChoice_3] = useState(false);
    const [patientInfo, setPatientInfo] = useState(null);
    let [contactId, setContactId] = useState('');
    let [contactInfo, setContactInfo] = useState({
        "contact_id": "",
        "bu_code": "",
        "hn": "",
        "full_name": "",
        "date_of_birth": "",
        "gender": "",
        "nationality": "",
        "citizen_id": "",
        "passport_no": "",
        "email": "",
        "mobile": "",
        "unique_key": ""
    });

    useEffect(() => {
        if(onceMounth.current)
        {
            pageInit();
            onceMounth.current = false;
        }
    }, [])

    useEffect(() => {
        if(choice_1 && choice_2 && choice_3)
        {
            $('.submit').fadeIn();
            setCanPass(true);
        }else
        {
            $('.submit').fadeOut();
            setCanPass(false);
        }
    }, [choice_1, choice_2, choice_3])

    const pageInit = async() => {
        await pageURLInit();
        await econsetInit();
        isPageLoading(false);
    }

    const pageURLInit = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            resolve();
        })
    }

    const econsetInit = () => {
        return new Promise(async resolve => {
            try{
                let payload = {};
                let reqData = {};
                let headers = {};
                let patient_info = {};
    
                //! Group Data
                if(type === 'signin'){ //? มีข้อมูลเพื่อมาเรียกเส้น get contact (e-consent) อยู่แล้ว
                    let patientData = await getPatientProfile();
                    patient_info = patientData.data;
                    let jwtData = await getJWTbyPatientID(patientData.data.patientid);
                    payload = {mobile: patientData.data.phonenumber}
                    reqData = {data: EncryptedOBJ(payload)};
                    headers = {
                        token: jwtData.token,
                        userRef: patientData.data.patientid,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
                }else if(type === 'signup'){ //? ไม่มีข้อมูลเพื่อเรียกเส้น get contact ต้องเช็คว่าเป็น membershipt lab, nonlab ไหมเพื่อนำ phone number มาใช้เรียก get contact
                    let isMemberShipLab = await isMembership();
                    let isMemberShipNonLab = await isMembershipNonLab();
                    //? เป็น membership lab, nonlab ไหม ?
                    if(isMemberShipLab === true || isMemberShipNonLab === true){
                        let phoneNumber = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_USER_PHONE) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_USER_PHONE)) : null;
                        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                        let udid = lineProfile.user_id;
                        let jwtData = await getJWT();
    
                        if(!!phoneNumber){
                            payload = {mobile: phoneNumber}
                            reqData = {data: EncryptedOBJ(payload)};
                            headers = {
                                token: jwtData.token,
                                userRef: udid,
                                authorizeRef: jwtData.authorizeRef,
                                channalRef: jwtData.channalRef
                            }
                        }else{
                            // ALERT.customAlert('เกิดข้อผิดพลาด', 'ไม่พบข้อมูลสำหรับยืนยันตัวตน กรุณาติดต่อเจ้าหน้าที่', 'ตกลง');          
                        }
                    }else{ //? ถ้าไม่ได้เป็น membership เลย แสดงว่ายังไม่เคยทำ consent มาก่อน
                        // show consent
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT, EncryptedText('true'));
                        resolve();
                    }
                }else{
                    // ALERT.customAlert('เกิดข้อผิดพลาด', 'ไม่พบประเภทการทำรายการ โปรดติดต่อเจ้าหน้าที่', 'ตกลง');    
                }
    
                //! Check Consent ว่าเคยมีการทำ consent ไปแล้วไหม ?
                
                if(type === 'signin'){
                    await getContact(reqData, headers).then(async res => {
                        console.log('Get Contact: ', res);
                        if(res.success === true){
                            let data = res.data;
                            if(!!data && data.length > 0){
                                //? เมื่อมีมากกว่า 0 ต้องนำ data ที่ได้มาเทียบกับเส้น get_all_consent ถ้ามีไม่ตรงกันก็ให้โชว์ consent 
                                let contact_id = data[0].contact_id;
                                setContactInfo(data[0]);
                                //? เปรียบเทียบ consent
                                let compareStatus = await compareConsent(contact_id, patient_info).catch(() => resolve())
                                if(compareStatus === true){
                                    //? ถ้าแมทช์แสดงว่าเคยทำ consent แล้ว ให้ไปสเต็ปถัดไปได้เลย
                                    passToNextStep();
                                }else
                                {
                                    //? ไม่แมทช์ ต้องทำ consent
                                    // show consent
                                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT, EncryptedText('true'));
                                    resolve();
                                }
        
                            }else{ //? ไม่เคยทำ consent
                                // show consent
                                localStorage.setItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT, EncryptedText('true'));
                                resolve();
                            }
                        }else{
                            // ALERT.customAlert('เกิดข้อผิดพลาด', 'บริการไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อเจ้าหน้าที่', 'ตกลง');
                        }
                    })
                }else resolve();
            } catch(err){
                console.log('Error: ', err);
                resolve();
            }
        })
    }

    const compareConsent = async(contact_id, patient_info) => {
        return new Promise(async (resolve, reject) => {
            let payload = { 
                contact_id: contact_id,
                consent_channel_code: "nh_marketing_contact_call,nh_marketing_contact_sms,nh_marketing_contact_email,nh_data_sharing,nh_lab_analysis_data"
            }
            let reqData = {
                data: EncryptedOBJ(payload)
            }
            let headers = {};
            if(type === 'signin'){
                let jwtData = await getJWTbyPatientID(patient_info.patientid);
                headers = {
                    token: jwtData.token,
                    userRef: patient_info.patientid,
                    authorizeRef: jwtData.authorizeRef,
                    channalRef: jwtData.channalRef
                }
            }
            if(type === 'signup'){
                let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                let udid = lineProfile.user_id;
                let jwtData = await getJWT();
                headers = {
                    token: jwtData.token,
                    userRef: udid,
                    authorizeRef: jwtData.authorizeRef,
                    channalRef: jwtData.channalRef
                }
            }
            await getAllConsent(reqData, headers)
            .then(res => {
                console.log('Get All Consent: ', res);
                if(res.success === true){
                    if(res.data.length > 0){
                        let consentData = res.data[0].consent;
                        console.log('consentData: ', consentData);
                        let data_1 = ["nh_marketing_contact_call","nh_marketing_contact_sms","nh_marketing_contact_email", "nh_data_sharing", "nh_lab_analysis_data"];
                        console.log('data_1: ', data_1);
                        let data_2 = consentData.map(item => item.consent_channel_code); 
                        console.log('data_2: ', data_2);
                        let compareStatus = compareArrays(data_1, data_2);
                        resolve(compareStatus);
                    }else throw Error('error');
                }else{
                    reject();
                    // ALERT.customAlert('เกิดข้อผิดพลาด', res.message, 'ปิด');
                }
            })
        })
        function compareArrays(arr1, arr2) {
            if (arr1.length !== arr2.length) {
              return false; // Arrays don't have the same length, so they can't be identical.
            }
          
            // Sort both arrays and check if all elements are the same.
            const sortedArr1 = [...arr1].sort();
            const sortedArr2 = [...arr2].sort();
          
            return sortedArr1.every((value, index) => value === sortedArr2[index]);
        }
    }

    const getPatientProfile = () => {
        return new Promise(async resolve => {
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
            console.log('patientData: ', patientData);
            let jwtData = await getJWTbyPatientID(patientData.data.patientid);
            
            let headers = {
                token: jwtData.token,
                userRef: patientData.data.patientid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }
            let rawReq = {
                "refEXP": patientData.refEXP,
                "isType": patientData.isType,
                "refAction": patientData.refAction,
                "refType": patientData.refType,
            }
            let reqData = {
                data: EncryptedOBJ(rawReq)
            }

            NhealthAction.GetPatientProfile(reqData, headers)
            .then(res => {
                console.log('Get Patient Profile Res: ', res);
                if(res.IsSuccess)
                {
                    setPatientInfo(res.data)
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA, EncryptedOBJ(res))
                    resolve(res);
                }
            })
        })
    }

    const handleChange = (e, index) => {
        let value = JSON.parse(e.target.value);

        if(index === 1)
        {
            setChoice_1(value);
            if(value)
            {
                
                $('.yes-1-wrap').css("border", "1px solid #007AFF");
                $('.no-1-wrap').css("border", "1px solid #D8D8D8");
            }else
            {
                $('.yes-1-wrap').css("border", "1px solid #D8D8D8");
                $('.no-1-wrap').css("border", "1px solid #007AFF");
            }
        }
        if(index === 2)
        {
            setChoice_2(value);
            if(value)
            {
                
                $('.yes-2-wrap').css("border", "1px solid #007AFF");
                $('.no-2-wrap').css("border", "1px solid #D8D8D8");
            }else
            {
                $('.yes-2-wrap').css("border", "1px solid #D8D8D8");
                $('.no-2-wrap').css("border", "1px solid #007AFF");
            }
        }
        if(index === 3)
        {
            setChoice_3(value);
            if(value)
            {
                
                $('.yes-3-wrap').css("border", "1px solid #007AFF");
                $('.no-3-wrap').css("border", "1px solid #D8D8D8");
            }else
            {
                $('.yes-3-wrap').css("border", "1px solid #D8D8D8");
                $('.no-3-wrap').css("border", "1px solid #007AFF");
            }
        }
    }

    const onSubmit = async() => {
        //! Set Consent (เฉพาะ type "signin" เพราะ "signup" จะเป็น set consent หลังจาก Register สำเร็จแล้ว)
        await handlerSetConsent()
    }

    const handlerSetConsent = async () => {
        return new Promise(async (resolve, reject) => {
            try{
                //? Type SignIn
                if (type === 'signin') {
                    //? Group Contact Payload
                    let contactPayload = {
                        hn: "",
                        title: "",
                        first_name: patientInfo.name_th,
                        middle: "",
                        last_name: patientInfo.surname_th,
                        date_of_birth: patientInfo.birthday,
                        gender: patientInfo.gender,
                        nationality: patientInfo.isForeign ? "UNKHOWN" : "TH",
                        citizen_id: patientInfo.isForeign ? "" : patientInfo.lab_identity_id,
                        passport_no: patientInfo.isForeign ? patientInfo.lab_identity_id : "",
                        passport_expire_date: "",
                        email: patientInfo.email,
                        mobile: patientInfo.phonenumber
                    }
                    console.log('contactPayload: ', contactPayload);
                    let reqData = {
                        data: EncryptedOBJ(contactPayload)
                    }
                    let jwtData = await getJWTbyPatientID(patientInfo.patientid);
                    let headers = {
                        token: jwtData.token,
                        userRef: patientInfo.patientid,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
                    //? Set Contact and Consent
                    if(!!contactInfo.contact_id){ //? ถ้ามี ContactId แสดงว่าไม่ต้องเซท contact ใหม่
                        handleSetConsent(contactInfo.contact_id);
                    }else{
                        await setContact(reqData, headers)
                            .then(async contactRes => {
                                //! Set Contact Success
                                if (contactRes.success === true) {
                                    handleSetConsent(contactRes.data.contact_id);
                                }else{
                                    passToNextStep();
                                    // ALERT.customAlert('เกิดข้อผิดพลาด', contactRes.message, 'ปิด');
                                }
                            })
                    }
                } else //? Type SignUp
                {
                    // go to signup step
                    location.href = `${Base_API.pathWeb}/n-health/signup/overview`;
                }
            }catch(err){
                console.log('Error: ', err);
                if(type === 'signin'){
                    passToNextStep();
                } else location.href = `${Base_API.pathWeb}/n-health/signup/overview`;
            }
        })
    }

    const handleSetConsent = async(contact_id) => {
        //? Group Consent Payload
        let consentPayload = {
            consent_date: moment().format('YYYY-MM-DD'),
            expire_date: "",
            contact_id: contact_id,
            consent: [
                {
                    consent_key_type: "mobile_phone",
                    consent_key: contactInfo.mobile,
                    consent_channel_code: "nh_marketing_contact_call",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "mobile_phone",
                    consent_key: contactInfo.mobile,
                    consent_channel_code: "nh_marketing_contact_sms",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "email",
                    consent_key: contactInfo.email,
                    consent_channel_code: "nh_marketing_contact_email",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "hn",
                    consent_key: "",
                    consent_channel_code: "nh_data_sharing",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "citizen_id",
                    consent_key: patientInfo.isForeign === true ? "" : patientInfo.lab_identity_id,
                    consent_channel_code: "nh_data_sharing",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "passport_no",
                    consent_key: patientInfo.isForeign === true ? patientInfo.lab_identity_id : "",
                    consent_channel_code: "nh_data_sharing",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "email",
                    consent_key: contactInfo.email,
                    consent_channel_code: "nh_data_sharing",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "mobile_phone",
                    consent_key: contactInfo.mobile,
                    consent_channel_code: "nh_data_sharing",
                    consent_flag: true
                }, 
                {
                    consent_key_type: "hn",
                    consent_key: "",
                    consent_channel_code: "nh_lab_analysis_data",
                    consent_flag: true
                },
                {
                    consent_key_type: "citizen_id",
                    consent_key: patientInfo.isForeign === true ? "" : patientInfo.lab_identity_id,
                    consent_channel_code: "nh_lab_analysis_data",
                    consent_flag: true
                },
                {
                    consent_key_type: "passport_no",
                    consent_key: patientInfo.isForeign === true ? patientInfo.lab_identity_id : "",
                    consent_channel_code: "nh_lab_analysis_data",
                    consent_flag: true
                }
            ]
        }
        let consentReqData = {
            data: EncryptedOBJ(consentPayload)
        }
        let consentJwtData = await getJWTbyPatientID(patientInfo.patientid);
        let consentHeaders = {
            token: consentJwtData.token,
            userRef: patientInfo.patientid,
            authorizeRef: consentJwtData.authorizeRef,
            channalRef: consentJwtData.channalRef
        }
        await setConsent(consentReqData, consentHeaders)
            .then(consentRes => {
                if (consentRes.success) {
                    //! Set Consent Success
                    passToNextStep();
                } else {
                    passToNextStep();
                    // ALERT.customAlert('เกิดข้อผิดพลาด', consentRes.message, 'ปิด');
                }
            })

    }

    const passToNextStep = () => {
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT); //? เอาไว้เช็คกับ flow register เพื่อให้ register รู้ว่าต้องทำ consent ไหม
        let callbackURL = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_CALLBACKURL_PRIVACY_POLICY)) : null;
        if(!!callbackURL){
            location.href = callbackURL; 
        }else{
            // ALERT.customAlert('เกิดข้อผิดพลาด', 'ไม่พบ Callback URL เพื่อดำเนินการต่อ', 'ปิด');
        }
    }

    return (
        <div className='sgn-pvcplc-con'>
            <div className='group'>
                <div className="item">
                    <p>ยินยอมให้สถานบริการตรวจวิเคราะห์ทางห้องปฏิบัติการทำการเก็บรวบรวม ใช้ และประมวลผลข้อมูลส่วนบุคคลเพื่อใช้ดำเนินการทางการตลาด การติดต่อสื่อสาร การนำเสนอโปรโมชั่นสินค้าและบริการ</p>
                    <div className="group-btn">
                        <label 
                            htmlFor={`yes-1`} className="left yes-1-wrap" >
                            <input id={`yes-1`} value={true} type="radio" name={`status-1`} onChange={(e) => handleChange(e, 1)} />
                            <label htmlFor={`yes-1`}>ยินยอม</label>
                        </label> 
                        <label htmlFor={`no-1`} className="right no-1-wrap">
                            <input id={`no-1`} value={false} type="radio" name={`status-1`} onChange={(e) => handleChange(e, 1)} />
                            <label htmlFor={`no-1`}>ไม่ยินยอม</label>
                        </label> 
                    </div>
                </div>
                <div className="item">
                    <p>ยินยอมให้แชร์ข้อมูลไปยังบริษัทในเครือ N-Health (ใส่ชื่อบริษัทในเครือ)</p>
                    <div className="group-btn">
                        <label 
                            htmlFor={`yes-2`} className="left yes-2-wrap">
                            <input id={`yes-2`} value={true} type="radio" name={`status-2`} onChange={(e) => handleChange(e, 2)} />
                            <label htmlFor={`yes-2`}>ยินยอม</label>
                        </label> 
                        <label htmlFor={`no-2`} className="right no-2-wrap">
                            <input id={`no-2`} value={false} type="radio" name={`status-2`} onChange={(e) => handleChange(e, 2)} />
                            <label htmlFor={`no-2`}>ไม่ยินยอม</label>
                        </label> 
                    </div>
                </div>
                <div className="item">
                    <p>ยินยอมให้ทำการตรวจวิเคราะห์สภาวะสุขภาพ</p>
                    <div className="group-btn">
                        <label 
                            htmlFor={`yes-3`} className="left yes-3-wrap">
                            <input id={`yes-3`} value={true} type="radio" name={`status-3`} onChange={(e) => handleChange(e, 3)} />
                            <label htmlFor={`yes-3`}>ยินยอม</label>
                        </label> 
                        <label htmlFor={`no-3`} className="right no-3-wrap">
                            <input id={`no-3`} value={false} type="radio" name={`status-3`} onChange={(e) => handleChange(e, 3)} />
                            <label htmlFor={`no-3`}>ไม่ยินยอม</label>
                        </label> 
                    </div>
                </div>
            </div>

            <div className="submit">
                <button onClick={canPass ? onSubmit : null}>
                    ยืนยัน
                </button>
            </div>

            <PageLoader/>
            <SignIn_Navbar canClose={false} />
        </div>
    )
}

export default SignIn_PrivacyPolicy